<template>
  <div>
    <BlNavBarMv title="Kategori Kelas" has-back-button style="border-bottom: 1px solid #ebebeb" @handleBackButtonClick="toLandingPage" />
    <PrakerjaListWithIconError
      v-if="isError.categoriesConfig"
      info="Yah, infonya belum berhasil dimuat. Silakan coba muat ulang, ya."
      class="fullheight qa-error-category-list"
      @reload="fetchCategoriesConfig"
    />
    <template v-else>
      <PrakerjaListWithIcon
        v-if="!isAppLoading && categoriesConfig.length"
        :list="categoriesConfig"
        more-button-link="categories"
        class="mt-20"
      />
      <PrakerjaListWithIconShimmer v-else :count="20" class="mt-16" />
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {BlNavBarMv} from '@bukalapak/bazaar-mweb-latest';

import PrakerjaListWithIcon from '../components/PrakerjaLandingPage/PrakerjaListWithIcon';
import PrakerjaListWithIconShimmer from '../components/PrakerjaLandingPage/PrakerjaListWithIconShimmer';
import PrakerjaListWithIconError from '../components/PrakerjaLandingPage/PrakerjaListWithIconError';

export default {
  name: 'PrakerjaCategoryListPage',
  components: {
    BlNavBarMv,
    PrakerjaListWithIcon,
    PrakerjaListWithIconShimmer,
    PrakerjaListWithIconError,
  },
  computed: {
    ...mapGetters(['isAppLoading']),
    ...mapGetters({
      categoriesConfig: 'categories/getCategoriesConfigAlphabetical',
      isError: 'getError',
    }),
  },
  mounted() {
    window.scrollTo(0, 0);
    if (!this.categoriesConfig.length) this.fetchCategoriesConfig();
  },
  methods: {
    toLandingPage() {
      this.$router.push({name: 'landing', query: this.$route.query});
    },
    fetchCategoriesConfig() {
      this.$store.dispatch('categories/fetchCategoriesConfig');
    },
  },
};
</script>

<style scoped>
.fullheight {
  height: calc(100vh - 180px);
}
</style>
